import statesConfig, { defaultState } from "@/lib/states-config";

export default function getCurrentStateConfig(state: string) {
  return statesConfig[state as keyof typeof statesConfig] || defaultState;
}
